import { render } from "./AddScontract.vue?vue&type=template&id=0168c477"
import script from "./AddScontract.vue?vue&type=script&lang=js"
export * from "./AddScontract.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__